import { gql } from '@apollo/client';

export * from './applyCoupon.mutation.generated';

export const APPLY_COUPON = gql`
  mutation applyCoupon($couponCode: String!) {
    applyCoupon(input: { couponCode: $couponCode }) {
      success
      errors
      company {
        id
        subscriptionExclusiveCouponAppliedAt
      }
    }
  }
`;
